export const mustCheck = (boolean: boolean): string => {
  return boolean ? '' : 'チェックが必須です'
}
